<template>
	<div class="about">
      <div class='title'>关于我们</div>
      <div class='content'>
        <p>
          　　辽宁思凯科技股份有限公司成立于2009年，是中国首个智能燃气表、水表的发明者与产品供应商。公司致力于以新一代5G物联网与智能感知技术，重塑燃气、水等能源管理方式，提供智慧能源管理全套解决方案。公司为国内同行业物联网产品第一梯队企业，市场占有率与技术水平在华北、东北地区与辽宁省内排名第一，产品系辽宁首创的首台套产品。公司是国际上目前唯一同时拥有高、中、低压超声波燃气计量产品，并且通过MID欧盟认证的企业。
        </p>
        <p>
          　　深耕行业近三十年，思凯科技不断创新提高计量技术与行业物联网产品应用，在行业发展过程中促进计量产品与云平台技术的科技成果转化，积极响应市场与能源公司（燃气公司、自来水公司）需求，主动承担社会责任，认真探索精准计量、大数据采集分析应用系统平台，加快建设面向社会的智慧能源（燃气、水）解决方案，为社会服务。企业智能燃气表及系统曾被住建部列为“国家‘九五’科技攻关项目突出科技成果奖”、“住宅建设推荐产品”、“国家重点新产品”等。思凯科技研发中心被认定为
          “辽宁省省级企业技术中心”、 “省级工程技术中心”、“省级工业设计中心”。
          2015年企业入选“国家级互联网与工业融合创新试点企业”；2019年入选国家工信部
          “企业上云典型案例”；2020年入选工信部2020-2021年度物联网关键技术与平台创新类项目；2021年企业产品入选辽宁省首台套重大技术装备认定产品目录；2019-2021年企业多项产品入选辽宁省高质量发展推荐产品目录等。公司获得专利及软件著作权近160余项，参编各类国家、行业标准20多项。荣获“高新技术企业”、“国家级服务型制造示范企业”、
          国家三级信息系统集成及服务认证单位、辽宁省知识产权优势企业、辽宁省绿色工厂等多项资质。</p>
        <p>
          　　公司在行业中连续主导研发并成功推广物联网膜式智能燃气表、物联网智能水表、5G物联网超声波智能燃气表、5G物联网超声波智能水表、具大数据分析的云服务系统等具有行业竞争力的代表性产品，率先在北京、上海及珠三角、长三角、河南、河北、华北、东北等90多个城市的燃气公司与自来水公司实现规模化应用，，与我国最大的燃气集团、水务集团建立了长期稳定的合作关系，在用表具800余万，具有成熟的营销网络，市场前景良好。
        </p>
      </div>
    </div>
</template>

<script>
	export default {
	  name: 'About',
	  components: {

		  },
		  
	  props: {
	    // msg: String
	  }
	}
</script>

<style scoped>

  /* 在这里添加针对手机屏幕的样式 */
  .about {
    width: 82%;
    margin: 15vw auto;
    text-align: left;
  }

  .title {
    color: #333333;
    font-size: 5vw;
    margin-bottom: 20px;
  }

  .content {
    font-size: 4vw;
    color: #666;
    line-height: 6.75vw;
  }
  .content p {
    margin-bottom: 20px;
  }

  @media (min-width: 768px) {
  .about {
    width: 680px;
    margin: 80px auto;
  }
  .title {
    font-size: 30px;
    margin-bottom: 50px;
  }

  .content{
    font-size: 18px;
    line-height: 30px;
  }
}

@media (min-width: 960px) {
  .about{
    width: 900px;
  }

}

@media (min-width: 1200px) {
  .about {
    width: 1200px;
  }

}
</style>